import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { AppCard, AppCardTitle, AppPageHeader } from '../../components';
import { UserPageViewsTable } from '../../components/Admin';

export default function UserPageViewsPage() {
	const { user_id } = useParams<{ user_id: string }>();
	const navigate = useNavigate();
	const location = useLocation();
	const userId = parseInt(user_id!, 10);

	const { userEmail, userName } = (location.state as { userEmail?: string; userName?: string }) ?? {};
	const userLabel = userName || userEmail || `User #${userId}`;

	return (
		<>
			<AppPageHeader>
				<Stack direction="row" alignItems="center" spacing={2} mb={1}>
					<Button
						size="small"
						startIcon={<ArrowBackIcon />}
						onClick={() => navigate('/admin/users')}
					>
						All Users
					</Button>
				</Stack>
				<Typography variant="h6">Page Views</Typography>
				<Typography variant="body2" color="text.secondary">
					{userLabel}
				</Typography>
			</AppPageHeader>
			<AppCard>
				<AppCardTitle>Page Views</AppCardTitle>
				<UserPageViewsTable userId={userId} />
			</AppCard>
		</>
	);
}
